// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ykBZy","search":"styles_search__tsfyf","icon":"styles_icon__fJTzk","infoIcon":"styles_infoIcon__v9zWX"};